import CryptoJS from 'crypto-js';
import AES from 'crypto-js/aes';
import { COOKIE_AUTH_DETAILS, COOKIE_ENCRYPT_KEY, COOKIE_FM_AUTH_DETAILS } from 'globalconfig/constants/keys';
import cookie from 'react-cookies';
import { enterpriseFeaturesKeyMapperHandler } from 'globalutils/featureMapHandler';
import { IS_ADMIN } from 'globalconfig/constants/validation';

const cookieExpiry = window?.$environment?.COOKIE_EXPIRY;

const encryptData = (data) => {
  return AES.encrypt(JSON.stringify(data), COOKIE_ENCRYPT_KEY).toString();
};

export const setFMCookie = (cname, cvalue, rememberMe, exdays = cookieExpiry) => {
  const encryptedData = AES.encrypt(JSON.stringify(cvalue), COOKIE_ENCRYPT_KEY).toString();
  if (rememberMe) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 168 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();

    if (cname == COOKIE_FM_AUTH_DETAILS) {
      let entDto = cvalue?.enterpriseFeaturesDto;
      let auth_without_entDto = JSON.parse(JSON.stringify(cvalue));
      delete auth_without_entDto.enterpriseFeaturesDto;

      document.cookie = `${cname}=${encryptData(auth_without_entDto)};${expires};path=/`;
      document.cookie = `${cname}_1=${encryptData(entDto)};${expires};path=/`;
    } else document.cookie = `${cname}=${encryptedData};${expires};path=/`;
  } else {
    if (cname == COOKIE_FM_AUTH_DETAILS) {
      let entDto = cvalue?.enterpriseFeaturesDto;
      let auth_without_entDto = JSON.parse(JSON.stringify(cvalue));
      delete auth_without_entDto.enterpriseFeaturesDto;

      document.cookie = `${cname}=${encryptData(auth_without_entDto)};path=/`;
      document.cookie = `${cname}_1=${encryptData(entDto)};path=/`;
    } else document.cookie = `${cname}=${encryptedData};path=/`;
  }
};

export const setCookie = (cname, cvalue, rememberMe, exdays = cookieExpiry) => {
  const encryptedData = AES.encrypt(JSON.stringify(cvalue), COOKIE_ENCRYPT_KEY).toString();
  if (rememberMe) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 168 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();

    if (cname == COOKIE_AUTH_DETAILS) {
      let entDto = cvalue?.enterpriseFeaturesDto;
      let auth_without_entDto = JSON.parse(JSON.stringify(cvalue));
      delete auth_without_entDto.enterpriseFeaturesDto;

      document.cookie = `${cname}=${encryptData(auth_without_entDto)};${expires};path=/; Secure; SameSite=None`;
      document.cookie = `${cname}_1=${encryptData(entDto)};${expires};path=/; Secure; SameSite=None`;
    } else document.cookie = `${cname}=${encryptedData};${expires};path=/; Secure; SameSite=None`;
  } else {
    if (cname == COOKIE_AUTH_DETAILS) {
      let entDto = cvalue?.enterpriseFeaturesDto;
      let auth_without_entDto = JSON.parse(JSON.stringify(cvalue));
      delete auth_without_entDto.enterpriseFeaturesDto;

      document.cookie = `${cname}=${encryptData(auth_without_entDto)};path=/; Secure; SameSite=None`;
      document.cookie = `${cname}_1=${encryptData(entDto)};path=/; Secure; SameSite=None`;
    } else document.cookie = `${cname}=${encryptedData};path=/; Secure; SameSite=None`;
  }
};

const paseCookieData = (data) => {
  return JSON.parse(AES.decrypt(data, COOKIE_ENCRYPT_KEY).toString(CryptoJS.enc.Utf8));
};

export const getCookie = (cname) => {
  const name = cname + '=';
  const ca = document.cookie.split(';');
  let decryptedData = null;

  if (cname === COOKIE_AUTH_DETAILS) {
    let data = cookie.load(COOKIE_AUTH_DETAILS) || '';
    if (data) {
      try {
        decryptedData = paseCookieData(data);
        if (!IS_ADMIN) {
          decryptedData.enterpriseFeaturesDto = paseCookieData(cookie.load(`${COOKIE_AUTH_DETAILS}_1`));
        }
      } catch (err) {
        cookie.remove(cname, { path: '/' });
        if (!IS_ADMIN) {
          cookie.remove(`${cname}_1`, { path: '/' });
        }
      }
      if (decryptedData)
        return {
          ...decryptedData,
          ...(!IS_ADMIN && {
            enterpriseFeatureDto: enterpriseFeaturesKeyMapperHandler(decryptedData)?.enterpriseFeatureDto,
            subscriptions: enterpriseFeaturesKeyMapperHandler(decryptedData)?.subscriptions,
          }),
        };
    }
  } else {
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        const data = c.substring(name.length, c.length);
        decryptedData = paseCookieData(data);
      }
    }
  }
  return decryptedData;
};

export const checkCookie = (name) => {
  const user = getCookie(name);
  if (user !== '') {
    return true;
  } else {
    return false;
  }
};

export const deleteCookie = (cname) => {
  cookie.remove(cname, { path: '/' });
  if (cname == COOKIE_AUTH_DETAILS && !IS_ADMIN) {
    cookie.remove(`${cname}_1`, { path: '/' });
  }
};
